// src/pages/PrivacyPolicyPage.js
import React from "react";
import { FiShield, FiMail, FiCalendar } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-theme-bg min-h-screen py-20 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-[40px] border border-component-border p-12 mb-8 shadow-sm">
          <div className="w-16 h-16 bg-orange-50 text-[#ff7a00] rounded-2xl flex items-center justify-center text-3xl mb-8">
            <FiShield />
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-theme-text tracking-tight mb-4 font-display">
            {t("privacyPage.title", "Privacy Policy")}
          </h1>
          <div className="flex items-center gap-2 text-theme-muted font-black text-[10px] uppercase tracking-widest">
            <FiCalendar className="text-chafadi-primary" />
            {t("privacyPage.lastUpdated", "Last Updated: April 18, 2026")}
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-[40px] border border-component-border p-8 md:p-12 shadow-sm space-y-12">
          {t("privacyPage.sections", { returnObjects: true }).map((section, index) => (
            <section key={index} className="space-y-4">
              <h2 className="text-2xl font-black text-theme-text flex items-center gap-3">
                <span className="w-8 h-8 rounded-lg bg-theme-bg flex items-center justify-center text-xs text-chafadi-primary font-black">
                  {index + 1}
                </span>
                {section.title}
              </h2>
              
              {section.content && (
                <p className="text-theme-muted font-medium leading-relaxed">
                  {section.content}
                </p>
              )}

              {section.subsections && (
                <div className="grid grid-cols-1 gap-4 mt-4">
                  {section.subsections.map((sub, i) => (
                    <div key={i} className="bg-theme-bg p-6 rounded-3xl border border-component-border">
                      <h3 className="text-xs font-black text-chafadi-primary uppercase tracking-widest mb-2">
                        {sub.tag}
                      </h3>
                      <p className="text-sm font-bold text-theme-text italic">
                        {sub.content}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </section>
          ))}

          <section className="pt-8 border-t border-component-border">
            <div className="bg-theme-bg rounded-3xl p-8 flex flex-col md:flex-row items-center gap-8 border border-component-border">
              <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center text-chafadi-primary text-2xl shadow-sm border border-component-border">
                <FiMail />
              </div>
              <div className="text-center md:text-left">
                <h3 className="text-xl font-black text-theme-text mb-2">
                   {t("profilePage.questionsOrConcerns", "Questions or concerns?")}
                </h3>
                <p className="text-theme-muted font-medium">
                  {t("profilePage.reachOut", "Reach out to our privacy officer at")} 
                  <a href="mailto:support@chafadi.com" className="ml-2 text-chafadi-primary font-black border-b-2 border-chafadi-primary/20 hover:border-chafadi-primary transition-all">
                    support@chafadi.com
                  </a>
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
